import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {BhWorkbooksListComponent} from "./bh-workbooks-list.component";
import {AppPipesModule} from "../../../app.pipes.module";
import {RouterLink} from "@angular/router";
import {AppTranslocoRootModule} from "../../../app.transloco.module";


@NgModule({
  declarations: [BhWorkbooksListComponent],
  exports: [BhWorkbooksListComponent],
  imports: [
    CommonModule,
    AppPipesModule,
    RouterLink,
    NgOptimizedImage,
    AppTranslocoRootModule,
  ]
})
export class BhWorkbooksListModule { }
